<template>
    <el-card class="record-card" shadow="never" v-loading="loading">
        <!-- 头部 -->
        <div slot="header" class="card-header">
            <span class="card-title">记录</span>
            <el-button v-if="activeTab === 'follow'" type="primary" size="small" icon="el-icon-plus"
                @click="openAddRecord">添加记录</el-button>
            <el-button v-else type="primary" size="small" icon="el-icon-plus" @click="openAddTodo">添加待办</el-button>
        </div>

        <!-- 标签页 -->
        <el-tabs v-model="activeTab" type="border-card" class="record-tabs" @tab-click="handleTabClick">
            <!-- 跟进记录 -->
            <el-tab-pane label="跟进记录" name="follow">
                <el-table :data="followList" stripe size="small" style="width: 100%" empty-text="暂无跟进记录">
                    <el-table-column prop="createTime" label="录入时间" width="160" />
                    <el-table-column prop="contactTime" label="跟进时间" width="160" />
                    <el-table-column prop="nextTime" label="下次跟进时间" width="160" />
                    <el-table-column prop="trackStatus" label="跟进状态" width="120">
                        <template slot-scope="scope">
                            <el-tag size="mini">{{ trackStatusTurnLabel(scope.row.trackStatus) }}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="contactName" label="联系人" width="120" />
                    <el-table-column prop="managerName" label="负责人" width="120" />
                    <el-table-column prop="remark" label="备注" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span v-if="scope.row.remark">{{ scope.row.remark }}</span>
                            <span v-else>暂无</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="120" fixed="right">
                        <template slot-scope="scope">
                            <el-button type="text" size="mini" @click="editRecord(scope.row)">修改</el-button>
                            <el-button type="text" size="mini" style="color: #f56c6c"
                                @click="deleteRecord(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane>

            <!-- 待办记录 -->
            <el-tab-pane label="待办记录" name="todo">
                <el-table :data="todoList" stripe size="small" style="width: 100%" empty-text="暂无待办记录">
                    <el-table-column prop="createTime" label="录入时间" width="160" />
                    <el-table-column prop="todoTime" label="待办时间" width="160" />
                    <el-table-column label="提前提醒" width="100">
                        <template slot-scope="scope">提前{{ scope.row.notifyTime }}小时</template>
                    </el-table-column>
                    <el-table-column label="状态" width="100">
                        <template slot-scope="scope">
                            <el-tag size="mini" :type="scope.row.todoStatus == 1 ? 'success' : 'info'">
                                {{ todoStatusTurnLabel(scope.row.todoStatus) }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="contactName" label="联系人" width="120" />
                    <el-table-column prop="managerName" label="负责人" width="120" />
                    <el-table-column prop="remark" label="备注" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span v-if="scope.row.remark">{{ scope.row.remark }}</span>
                            <span v-else>暂无</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="120" fixed="right">
                        <template slot-scope="scope">
                            <el-button type="text" size="mini" @click="editTodo(scope.row)">修改</el-button>
                            <el-button type="text" size="mini" style="color: #f56c6c"
                                @click="deleteTodo(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane>
        </el-tabs>

        <!-- ==================== 弹窗：添加/修改跟进记录 ==================== -->
        <el-dialog :title="recordForm.trackId ? '修改跟进记录' : '添加跟进记录'" :visible.sync="showAddRecord" width="560px"
            :close-on-click-modal="false">
            <el-form ref="recordForm" :model="recordForm" label-width="90px" size="small">
                <el-form-item label="跟进时间" prop="trackTime">
                    <el-date-picker v-model="recordForm.trackTime" type="datetime" placeholder="选择日期时间"
                        style="width: 100%" value-format="yyyy-MM-dd HH:mm:ss" />
                </el-form-item>
                <el-form-item label="下次跟进" prop="nextTime">
                    <el-date-picker v-model="recordForm.nextTime" type="datetime" placeholder="选择日期时间"
                        style="width: 100%" value-format="yyyy-MM-dd HH:mm:ss" />
                </el-form-item>
                <el-form-item label="跟进状态" prop="trackStatus">
                    <el-select v-model="recordForm.trackStatus" placeholder="请选择" style="width: 100%">
                        <el-option v-for="item in trackStatusOptions" :key="item.value" :label="item.label"
                            :value="item.value" />
                    </el-select>
                </el-form-item>
                <el-form-item label="联系人" prop="contactId">
                    <el-select v-model="recordForm.contactId" placeholder="请选择" style="width: 100%">
                        <el-option v-for="item in contactList" :key="item.id" :label="item.contactName"
                            :value="item.id" />
                    </el-select>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input v-model="recordForm.remark" type="textarea" :rows="3" placeholder="请输入备注"
                        maxlength="500" show-word-limit />
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button size="small" @click="showAddRecord = false">取消</el-button>
                <el-button type="primary" size="small" :loading="submitting" @click="submitRecord">确定</el-button>
            </div>
        </el-dialog>

        <!-- ==================== 弹窗：添加/修改待办 ==================== -->
        <el-dialog :title="todoForm.todoId ? '修改待办' : '添加待办'" :visible.sync="showAddTodo" width="500px"
            :close-on-click-modal="false">
            <el-form ref="todoForm" :model="todoForm" label-width="80px" size="small">
                <el-form-item label="待办时间" prop="todoTime">
                    <el-date-picker v-model="todoForm.todoTime" type="datetime" placeholder="选择日期时间"
                        style="width: 100%" value-format="yyyy-MM-dd HH:mm:ss" />
                </el-form-item>
                <el-form-item label="提醒时间" prop="notifyTime">
                    <el-date-picker v-model="todoForm.notifyTime" type="datetime" placeholder="选择日期时间"
                        style="width: 100%" value-format="yyyy-MM-dd HH:mm:ss" />
                </el-form-item>
                <el-form-item label="待办状态" prop="todoStatus">
                    <el-select v-model="todoForm.todoStatus" placeholder="请选择" style="width: 100%">
                        <el-option label="待完成" :value="0" />
                        <el-option label="已完成" :value="1" />
                    </el-select>
                </el-form-item>
                <el-form-item label="联系人" prop="contactId">
                    <el-select v-model="todoForm.contactId" placeholder="请选择" style="width: 100%">
                        <el-option v-for="item in contactList" :key="item.id" :label="item.contactName"
                            :value="item.id" />
                    </el-select>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input v-model="todoForm.remark" type="textarea" :rows="3" placeholder="请输入备注" />
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button size="small" @click="showAddTodo = false">取消</el-button>
                <el-button type="primary" size="small" :loading="submitting" @click="submitTodo">确定</el-button>
            </div>
        </el-dialog>
    </el-card>
</template>

<script>
export default {
    name: 'RecordCard',
    props: {
        // 项目/客户id，由父组件传入
        projectId: { type: [Number, String], default: 0 },
        // 联系人列表（供下拉选择，由页面传入）
        contactList: { type: Array, default: () => [] }
    },
    data() {
        return {
            loading: false,
            submitting: false,
            activeTab: 'follow',
            followList: [],
            todoList: [],
            trackStatusOptions: [],

            showAddRecord: false,
            recordForm: { trackId: 0, trackTime: '', nextTime: '', trackStatus: '', contactId: '', remark: '' },

            showAddTodo: false,
            todoForm: { todoId: 0, todoTime: '', notifyTime: '', todoStatus: 0, contactId: '', remark: '' }
        }
    },
    computed: {
        // 后台接口命名空间，若与你项目里 $api 的配置不一致，只改这里即可
        trackApi() {
            return this.$api.common.ProjectTrack;
        },
        todoApi() {
            return this.$api.common.projectTodo;
        }
    },
    mounted() {
        if (this.projectId) {
            this.getTrackStatusList()
            this.getTrackList()
            this.getTodoList()
        }
    },
    watch: {
        projectId(val) {
            if (val) {
                this.getTrackStatusList()
                this.getTrackList()
                this.getTodoList()
            }
        },
        showAddRecord(val) { if (!val) this.resetRecordForm() },
        showAddTodo(val) { if (!val) this.resetTodoForm() }
    },
    methods: {
        // ==================== 跟进记录（写法同 index.vue） ====================
        // 跟踪状态列表
        getTrackStatusList() {
            let ajaxUrl = this.trackApi.trackStatusList();
            this.$axios.get(ajaxUrl).then((res) => {
                if (res.success) {
                    this.trackStatusOptions = res.list || [];
                }
            }).catch((err) => {
                console.error('getTrackStatusList err:', err);
            });
        },

        // 获取跟踪列表
        getTrackList() {
            let ajaxUrl = this.trackApi.list();
            this.loading = true;
            this.$axios.get(ajaxUrl, { params: { projectId: this.projectId } }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.followList = res.list || [];
                } else {
                    this.$message.error(res.msg);
                }
            }).catch((err) => {
                this.loading = false;
                console.error('getTrackList err:', err);
            });
        },

        // 跟踪详情
        getTrackDetail(trackId) {
            let ajaxUrl = this.trackApi.detail();
            this.$axios.get(ajaxUrl, { params: { trackId: trackId } }).then((res) => {
                if (res.success) {
                    this.recordForm = {
                        trackId: trackId,
                        trackTime: res.data.contactTime || '',
                        nextTime: res.data.nextTime || '',
                        trackStatus: res.data.status || '',
                        contactId: res.data.contactId || '',
                        remark: res.data.remark || ''
                    }
                    this.showAddRecord = true
                } else {
                    this.$message.error(res.msg)
                }
            }).catch((err) => {
                console.error('getTrackDetail err:', err);
            })
        },

        // 添加或修改跟踪信息（trackId=0 新增，大于0 更新）
        saveTrack() {
            let ajaxUrl = this.trackApi.post();
            this.submitting = true
            const params = {
                trackId: this.recordForm.trackId,
                projectId: this.projectId,
                trackTime: this.recordForm.trackTime,
                trackStatus: this.recordForm.trackStatus,
                contactId: this.recordForm.contactId || 0,
                nextTime: this.recordForm.nextTime,
                remark: this.recordForm.remark
            }
            // 后台要求 POST 走 $.ajax
            $.ajax({
                url: ajaxUrl,
                type: 'POST',
                data: params,
                success: (res) => {
                    this.submitting = false
                    if (res.success) {
                        this.$message({ type: 'success', message: '保存成功' })
                        this.showAddRecord = false
                        this.getTrackList()
                    } else {
                        this.$message.error(res.msg)
                    }
                },
                error: (err) => {
                    this.submitting = false
                    console.error('saveTrack err:', err);
                }
            })
        },

        // 删除跟踪信息
        deleteTrack(trackId) {
            this.$confirm('此操作将删除该记录, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let ajaxUrl = this.trackApi.delete();
                // 后台要求 POST 走 $.ajax
                $.ajax({
                    url: ajaxUrl,
                    type: 'POST',
                    data: { trackId: trackId },
                    success: (res) => {
                        if (res.success) {
                            this.$message({ type: 'success', message: '删除成功' })
                            this.getTrackList()
                        } else {
                            this.$message.error(res.msg)
                        }
                    },
                    error: (err) => {
                        console.error('deleteTrack err:', err);
                    }
                })
            }).catch(() => {})
        },

        // ==================== 待办记录（写法同 index.vue） ====================
        // 获取待办列表
        getTodoList() {
            let ajaxUrl = this.todoApi.list();
            this.$axios.get(ajaxUrl, { params: { projectId: this.projectId } }).then((res) => {
                if (res.success) {
                    this.todoList = res.list || []
                    // 把提醒时间换算成"提前N小时"
                    for (var i = 0; i < this.todoList.length; i++) {
                        this.todoList[i].notifyTime = this.getHour(
                            this.todoList[i].todoTime, this.todoList[i].notifyTime
                        )
                    }
                } else {
                    this.$message.error(res.msg)
                }
            }).catch((err) => {
                console.error('getTodoList err:', err);
            })
        },

        // 待办详情
        getTodoDetail(todoId) {
            let ajaxUrl = this.todoApi.detail();
            this.$axios.get(ajaxUrl, { params: { todoId: todoId } }).then((res) => {
                if (res.success) {
                    this.todoForm = {
                        todoId: todoId,
                        todoTime: res.data.todoTime || '',
                        notifyTime: res.data.notifyTime || '',
                        todoStatus: res.data.todoStatus || 0,
                        contactId: res.data.contactId || '',
                        remark: res.data.remark || ''
                    }
                    this.showAddTodo = true
                } else {
                    this.$message.error(res.msg)
                }
            }).catch((err) => {
                console.error('getTodoDetail err:', err);
            })
        },

        // 添加或修改待办信息（todoId=0 新增，大于0 更新）
        saveTodo() {
            let ajaxUrl = this.todoApi.post();
            this.submitting = true
            const params = {
                todoId: this.todoForm.todoId,
                projectId: this.projectId,
                todoTime: this.todoForm.todoTime,
                notifyTime: this.todoForm.notifyTime,
                todoStatus: this.todoForm.todoStatus,
                contactId: this.todoForm.contactId || 0,
                remark: this.todoForm.remark
            }
            // 后台要求 POST 走 $.ajax
            $.ajax({
                url: ajaxUrl,
                type: 'POST',
                data: params,
                success: (res) => {
                    this.submitting = false
                    if (res.success) {
                        this.$message({ type: 'success', message: '保存成功' })
                        this.showAddTodo = false
                        this.getTodoList()
                    } else {
                        this.$message.error(res.msg)
                    }
                },
                error: (err) => {
                    this.submitting = false
                    console.error('saveTodo err:', err);
                }
            })
        },

        // 删除待办信息
        deleteTodoFun(todoId) {
            this.$confirm('此操作将删除该记录, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let ajaxUrl = this.todoApi.delete();
                // 后台要求 POST 走 $.ajax
                $.ajax({
                    url: ajaxUrl,
                    type: 'POST',
                    data: { todoId: todoId },
                    success: (res) => {
                        if (res.success) {
                            this.$message({ type: 'success', message: '删除成功' })
                            this.getTodoList()
                        } else {
                            this.$message.error(res.msg)
                        }
                    },
                    error: (err) => {
                        console.error('deleteTodoFun err:', err);
                    }
                })
            }).catch(() => {})
        },

        // ==================== 工具方法 ====================
        // 跟进状态 value -> label
        trackStatusTurnLabel(value) {
            let res = ''
            this.trackStatusOptions.forEach(item => {
                if (item.value == value) {
                    res = item.label
                }
            })
            return res
        },

        // 待办状态 value -> label（0=待完成，1=已完成）
        todoStatusTurnLabel(value) {
            return value == 1 ? '已完成' : '待完成'
        },

        // 计算两个时间相差小时数
        getHour(startTime, endTime) {
            const start = new Date(startTime)
            const end = new Date(endTime)
            const diffMs = start - end
            const diffHours = diffMs / (1000 * 60 * 60)
            return diffHours.toFixed(2)
        },

        handleTabClick() {
            // 切换到待办时刷新列表，保证提醒小时数为最新
            if (this.activeTab === 'todo') this.getTodoList();
        },

        // ==================== 交互 ====================
        openAddRecord() {
            this.recordForm.trackId = 0
            this.showAddRecord = true
        },
        editRecord(row) {
            this.getTrackDetail(row.id)
        },
        deleteRecord(row) {
            this.deleteTrack(row.id)
        },
        submitRecord() {
            if (!this.recordForm.trackTime || !this.recordForm.trackStatus) {
                this.$message.warning('跟进时间和跟进状态不能为空')
                return
            }
            this.saveTrack()
        },
        resetRecordForm() {
            this.recordForm = { trackId: 0, trackTime: '', nextTime: '', trackStatus: '', contactId: '', remark: '' }
        },

        openAddTodo() {
            this.todoForm.todoId = 0
            this.showAddTodo = true
        },
        editTodo(row) {
            this.getTodoDetail(row.id)
        },
        deleteTodo(row) {
            this.deleteTodoFun(row.id)
        },
        submitTodo() {
            if (!this.todoForm.todoTime || !this.todoForm.notifyTime) {
                this.$message.warning('待办时间和提醒时间不能为空')
                return
            }
            this.saveTodo()
        },
        resetTodoForm() {
            this.todoForm = { todoId: 0, todoTime: '', notifyTime: '', todoStatus: 0, contactId: '', remark: '' }
        }
    }
}
</script>

<style lang="scss" scoped>
.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.card-title {
    font-size: 16px;
    font-weight: 600;
    color: #303133;
}

.record-card {
    ::v-deep .el-card__body {
        padding: 0;
    }
}

.record-tabs {
    ::v-deep .el-tabs__header {
        margin-bottom: 0;
    }

    ::v-deep .el-tabs__content {
        padding: 16px;
    }
}
</style>